import styled, { css } from '@xstyled/styled-components';
import React, { ChangeEventHandler, FC } from 'react';
import { Capsule, TickMarkCapsule } from '../capsules';

interface Props {
  variant: 'default' | 'checked';
}

const HiddenRadio = styled.input`
  clip-path: polygon(0 0);
  float: right;
`;

const Label = styled.labelBox<Props>`
  display: flex;
  align-items: center;
  border-radius: ${p => p.theme.radii.md};
  cursor: pointer;
  font-size: ${p => p.theme.fontSizes.sm};
  transition: 0.2s all linear;

  ${Capsule} {
    margin-right: ${p => p.theme.space.md};
  }
  ${p =>
    p.variant === 'checked'
      ? css`
          background: ${p.theme.colors.accentDark};
          font-weight: bold;
          font-size: md;
          color: #ffffff;
          ${Capsule} {
            background: ${p.theme.colors.white};
          }
        `
      : css`
          transition: 0.2s all linear;

          &:hover {
            background-color: greyLight;
          }
        `}
`;
// defaultProps for xstyled system props; cast to satisfy styled-component typings
(Label as React.ComponentType<unknown>).defaultProps = {
  py: { _: 'md', sm: 'sm' },
  px: { _: '', sm: 'md' },
  flexDirection: { _: 'row-reverse', sm: 'row' }
};

const Content = styled.span`
  flex: 1;
`;

const SubContent = styled.span`
  flex: 1;
  font-size: xs;
`;

export const PickListItem: FC<{
  checked?: boolean;
  value: string;
  additionalValue: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onKeyPress: any;
  name: string;
}> = ({
  checked,
  children,
  value,
  onChange,
  name,
  onKeyPress,
  additionalValue
}) => {
  return (
    <Label
      variant={checked ? 'checked' : 'default'}
      tabIndex={0}
      onKeyPress={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onKeyPress();
        }
      }}
      role="radio"
    >
      {checked ? <TickMarkCapsule /> : <Capsule />}
      <Content>
        {children} <br />
        <SubContent>{additionalValue}</SubContent>
      </Content>
      <HiddenRadio
        tabIndex={-1}
        type="radio"
        checked={checked}
        value={value}
        onChange={onChange}
        name={name}
      />
    </Label>
  );
};
